import { FlexWrapper, Spinner, Separator } from '@intigral/shared';
import { EpisodesItem } from './EpisodesItem';
import { SeasonList } from './SeasonList';
import { iEpisodeListProps } from '../types/iSeasons';
import { useEpisodeList } from '../hooks/useEpisodeList';
import { useMemo } from 'react';

export const EpisodesList: React.FC<iEpisodeListProps> = ({ setRuntimeLength, seasons, seasonOrderDescending }) => {
    const sortedSeasons = useMemo(() => {
        if (!seasons || seasons.length === 0) return seasons;
        if (seasonOrderDescending === true) {
            return [...seasons].reverse();
        }
        return seasons;
    }, [seasons, seasonOrderDescending]);

    const { mutation, episodes, setEpisodes } = useEpisodeList(sortedSeasons);

    if (mutation.isPending)
        return (
            <>
                <Separator theme="bg" marginTop="4x" />
                <Spinner block />
            </>
        );

    return (
        <FlexWrapper gap={{ default: '3x', md: '4x' }} direction="column">
            <SeasonList
                seasons={sortedSeasons}
                episodes={episodes}
                setEpisodes={setEpisodes}
                setRuntimeLength={setRuntimeLength}
            />
            {episodes?.map((episode, index) => {
                return <EpisodesItem key={episode?.Id || index} details={episode} />;
            })}
        </FlexWrapper>
    );
};
